angular
    .module('cvsApp').directive('persist', function (userSession) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {

            var model = attrs.ngModel,
                key = '__scopePersist_' + model,
                value = userSession.persit[key],
                type = attrs.persist || 'string',
                castValue;
            if (value) {
                switch (type) {
                    case 'bool':
                    case 'boolean':
                        castValue = 'true' === value;
                        break;
                    case 'int':
                    case 'integer':
                        castValue = parseInt(value, 10);
                        break;
                    case 'object':
                    case 'json':
                        castValue = JSON.parse(value);
                        break;
                    default:
                        castValue = value;
                }
                scope[model] = castValue;
            }

            scope.$watch(model, function (value) {
                if(value !== undefined){
                    userSession.persit[key] = value;
                }

            });
        }
    };
});